/* vr-roadmap.js — Vitality Roadmap interactions (WS-VITALITY). Vanilla, no deps. Safe with localStorage blocked. */
(function () {
  if (window.__vrRoadmap) return;
  window.__vrRoadmap = true;
  var COLORS = { micro: '#7567ED', gut: '#C9772F', calm: '#A99FFB', itch: '#D4A64A', weight: '#8FB35E' };
  var NAMES = { micro: 'Microbiome Care', gut: 'Gut Restore', calm: 'Calming Care', itch: 'Itch & Immune Care', weight: 'Metabolic Care' };
  var CONCERN = { daily: 'micro', gut: 'gut', calm: 'calm', itch: 'itch', weight: 'weight' };
  var BAND_LB = { u20: 15, '21-25': 23, '26-50': 38, '51-75': 63, o75: 85 };
  var LS = 'vr_roadmap_v1';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function init() {
    var tabsEl = $('[data-vr-tabs]');
    if (!tabsEl) return;
    var tabs = $$('[data-vr-tab]', tabsEl);
    var tl = $('[data-vr-tl]');
    var nodes = $$('[data-vr-node]');
    var live = $('[data-vr-live]');
    var slider = $('[data-vr-weight]');
    var st = { f: 'micro', step: 0, w: 30, picked: false };
    var saved = lsGet(LS) || { done: {} };
    if (!saved.done) saved.done = {};

    function planInfo() {
      var p = null;
      try { p = window.PlentumPlan && window.PlentumPlan.get && window.PlentumPlan.get(); } catch (e) {}
      if (!p) p = lsGet('plentum_plan_v1');
      return p;
    }
    function planFormula() {
      var q = '';
      try { q = new URLSearchParams(location.search).get('formula') || ''; } catch (e) {}
      if (NAMES[q]) return q;
      var p = planInfo();
      if (!p) return null;
      var k = CONCERN[p.concern];
      if (!k && p.formula) {
        var h = String(p.formula);
        k = /gut/.test(h) ? 'gut' : /calming/.test(h) ? 'calm' : /itch/.test(h) ? 'itch' : /metabolic/.test(h) ? 'weight' : /all-in-one|microbiome/.test(h) ? 'micro' : null;
      }
      return k || null;
    }

    function paintTier() {
      var panel = $('[data-vr-dose="' + st.f + '"]');
      if (!panel) return;
      var rows = $$('.vr-tier', panel), w = st.w, hit = rows[rows.length - 1];
      for (var i = 0; i < rows.length; i++) { if (rows[i].hasAttribute('data-max-exclusive') ? w < +rows[i].getAttribute('data-max') : w <= +rows[i].getAttribute('data-max')) { hit = rows[i]; break; } }
      rows.forEach(function (r) { r.classList.toggle('is-on', r === hit); });
      var s = +hit.getAttribute('data-s'), p = +hit.getAttribute('data-p');
      var a = $('[data-vr-sach]'), d = $('[data-vr-day]'), wv = $('[data-vr-wval]');
      if (a) a.textContent = s;
      if (d) d.textContent = '$' + (p / 30).toFixed(2);
      if (wv) wv.textContent = w;
    }

    function paintStep() {
      nodes.forEach(function (n, i) {
        n.setAttribute('aria-pressed', i === st.step ? 'true' : 'false');
        n.classList.toggle('is-reached', i <= st.step);
      });
      if (tl) tl.style.setProperty('--p', (st.step / 3).toFixed(3));
      $$('[data-vr-card]').forEach(function (c) { c.hidden = c.getAttribute('data-vr-card') !== st.f + '-' + st.step; });
      /* T-OWNERFIX-1020: the PDP-style timeline shows every stage of the chosen supplement at once */
      $$('[data-vr-phases]').forEach(function (l) { l.hidden = l.getAttribute('data-vr-phases') !== st.f; });
    }

    function paintChecklist() {
      var done = saved.done[st.f] || [];
      $$('[data-vr-cl]').forEach(function (l) { l.hidden = l.getAttribute('data-vr-cl') !== st.f; });
      var list = $('[data-vr-cl="' + st.f + '"]');
      if (!list) return;
      var boxes = $$('input[type=checkbox]', list);
      boxes.forEach(function (b, i) { b.checked = done.indexOf(i) > -1; });
      paintProgress(boxes);
    }
    function paintProgress(boxes) {
      var n = boxes.filter(function (b) { return b.checked; }).length, t = boxes.length;
      var bar = $('[data-vr-bar]'), txt = $('[data-vr-ptxt]');
      if (bar) { bar.setAttribute('aria-valuenow', n); bar.setAttribute('aria-valuemax', t); var i = bar.querySelector('i'); if (i) i.style.transform = 'scaleX(' + (t ? n / t : 0) + ')'; }
      if (txt) txt.textContent = n + ' of ' + t + ' done';
    }

    function setFormula(f, user) {
      if (!NAMES[f]) return;
      st.f = f; if (user) st.picked = true;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-vr-tab') === f;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      $$('[data-vr-blurb]').forEach(function (b) { b.hidden = b.getAttribute('data-vr-blurb') !== f; });
      $$('[data-vr-fpack]').forEach(function (b) { b.hidden = b.getAttribute('data-vr-fpack') !== f; });
      $$('[data-vr-dose]').forEach(function (b) { b.hidden = b.getAttribute('data-vr-dose') !== f; });
      $$('[data-vr-name]').forEach(function (n) { n.textContent = NAMES[f]; });
      document.documentElement.style.setProperty('--vr-c', COLORS[f]);
      $$('.vr-sec').forEach(function (s) { s.style.setProperty('--vr-c', COLORS[f]); });
      if (live && user) live.textContent = 'Showing the ' + NAMES[f] + ' roadmap';
      paintStep(); paintTier(); paintChecklist();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { setFormula(t.getAttribute('data-vr-tab'), true); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0; else if (k === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); tabs[j].focus(); setFormula(tabs[j].getAttribute('data-vr-tab'), true); }
      });
    });
    nodes.forEach(function (n, i) { n.addEventListener('click', function () { st.step = i; paintStep(); }); });
    if (slider) slider.addEventListener('input', function () { st.w = +slider.value; paintTier(); });
    $$('[data-vr-chk]').forEach(function (b) {
      b.addEventListener('change', function () {
        var p = b.getAttribute('data-vr-chk').split(':'), f = p[0], i = +p[1];
        var arr = saved.done[f] || [], at = arr.indexOf(i);
        if (b.checked && at < 0) arr.push(i); else if (!b.checked && at > -1) arr.splice(at, 1);
        saved.done[f] = arr; lsSet(LS, saved);
        paintProgress($$('input[type=checkbox]', b.closest('[data-vr-cl]')));
      });
    });

    function applyPlan() {
      var f = planFormula();
      if (f && !st.picked) setFormula(f, false);
      var p = planInfo();
      if (p && p.band && BAND_LB[p.band] && !st.wTouched) { st.w = BAND_LB[p.band]; if (slider) slider.value = st.w; paintTier(); }
    }
    if (slider) slider.addEventListener('pointerdown', function () { st.wTouched = true; });
    setFormula('micro', false);
    if (slider) st.w = +slider.value;
    paintTier();
    applyPlan();
    document.addEventListener('plentum:plan', applyPlan);
    window.addEventListener('load', applyPlan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
